import { useMemo } from 'react';

// Custom hook to replace spaces in a string with underscores
const useRemoveSpaces = (str) => {
  const ret = useMemo(() => str.replace(/\s+/g, '_'), [str]);
  return ret;
};

export default useRemoveSpaces;
